import * as React from 'react'
import { useState, useEffect } from 'react'
import './index.less'
import BannerCarousel from "../../components/BannerCarousel";
import Footer from '../../components/Footer'


import BannerDefaultImage from '../../assets/images/banner-default.png'

import PcBanner1Image from '../../assets/images/cy/PC-banner1.png'
import PcBanner2Image from '../../assets/images/cy/PC-banner2.png'
import PcBanner3Image from '../../assets/images/cy/PC-banner3.png'

import { getUpdateNotice } from '../../request/CyHomepage'
import {PanelContainer} from "../../components/PanelContainer";
import {UsersPanel} from "./components/UsersPanel";
import OurInfomation from "../../components/OurInfomation";
import {CommentContainer} from "./components/CommentContainer";

import {BasicFeaturePanel} from "./panels";
import ManageFeaturePanel from "./panels/ManageFeaturePanel";
import LaboratoryCommentPanel from "./panels/LaboratoryCommentPanel";
import {UpdateItem} from "./components";
import { ShowContainer } from './components/ShowContainer';
import {
  bannerStats,
  FOOTER_CONTENT,
  URL_CY_HELP,
  URL_CY_HELP_WAP, URL_CY_OVERVIEW,
  URL_CY_PRACTICE,
  URL_CY_PRACTICE_WAP
} from "../../constants/CyHomepage";
import cyLayout from "../../layout/cyLayout";
import Modal from "../../components/Modal";
import {INFOMATIONCONTENT} from "./components/InfomationContent";

const clsPrefix = 'p-cy-homepage'

interface NoticeItemProps {
  id: string | number
  coverImg: string
  title: string
  publicDate: string
  createTime: number
  updateTime: number
  content: string
}

//const chanyanHost = 'changyan.kuaizhan.com'

const CyHompage: React.FC<{}> = () => {
  //const [ isModalVisible, setIsModalVisible] = useState(false)
  const [ isNoticeModalVisible, setIsNoticeModalVisible] = useState(false);
  const [ noticeList, setNoticeList ] = useState<NoticeItemProps[]>([])
  const [ bannerData, setBannerData] = useState([
    {
      img: PcBanner1Image,
      url: URL_CY_HELP,
      wapUrl: URL_CY_HELP_WAP
    },
    {
      img: PcBanner2Image,
      url: URL_CY_PRACTICE,
      wapUrl: URL_CY_PRACTICE_WAP
    },
    {
      img: PcBanner3Image,
      url: URL_CY_OVERVIEW,
      wapUrl: ''
    }
  ])

  function adjustBanner() {
    if (window && window.screen.width < 1024) {
      // setBannerImgList([WapBannerDefaultImage, WapBannerOffcAccImage])
      setBannerData([
        {
          img: PcBanner1Image,
          url: URL_CY_HELP,
          wapUrl: URL_CY_HELP_WAP
        },
        {
          img: PcBanner2Image,
          url: URL_CY_PRACTICE,
          wapUrl: URL_CY_PRACTICE_WAP
        },
        {
          img: PcBanner3Image,
          url: URL_CY_OVERVIEW,
          wapUrl: ''
        }
      ])
    } else {
      const bannerDefault = new Image()
      bannerDefault.src = BannerDefaultImage

      bannerDefault.onload = function () {
        if (bannerDefault.complete) {
          setBannerData([
            {
              img: PcBanner1Image,
              url: URL_CY_HELP,
              wapUrl: URL_CY_HELP_WAP
            },
            {
              img: PcBanner2Image,
              url: URL_CY_PRACTICE,
              wapUrl: URL_CY_PRACTICE_WAP
            },
            {
              img: PcBanner3Image,
              url: URL_CY_OVERVIEW,
              wapUrl: ''
            }
          ])
        }
      }
    }
  }

  useEffect(() => {
    fetchUpdateNotice()
    window.addEventListener('resize', adjustBanner)
    return () => window.removeEventListener('resize', adjustBanner)
  }, [])

  function fetchUpdateNotice () {
    // 获取上次最新的更新公告的时间
    let startTime: number | string =
      localStorage.getItem('latest_update_notices_time') ?
      Number(localStorage.getItem('latest_update_notices_time')) : 0

    getUpdateNotice().then((res) => {
      setNoticeList(res?.data?.notices || [])
      const newNotices = res?.data?.notices?.filter(item => item.updateTime > startTime) || []
      console.log(newNotices, "newNotices")
      if (newNotices?.length > 0) {
        if (window.screen.width < 1024) {
          return
        }
        setIsNoticeModalVisible(true)
      }
    }).catch(err => console.log(err, 'err'))
  }

  function handleCloseModal () {
    setIsNoticeModalVisible(false)
    const newestTime = noticeList?.[0]?.updateTime
    if (!newestTime) {
      return
    }
    // 更新本次最新的更新公告的时间
    localStorage.setItem('latest_update_notices_time', String(newestTime))
  }

  return (
    <div className={clsPrefix}>
      <div className={`${clsPrefix}__screen ${clsPrefix}__screen-one`}>
        <div className='contents'>
          <div className='carousel'>
            <BannerCarousel
                imgList={bannerData}
                delay={5000}
                statPage='cy_homepage'
                bannerStats={bannerStats}
            />
          </div>
        </div>
      </div>

      <div className={`${clsPrefix}__screen ${clsPrefix}__screen-two`}>
        <CommentContainer></CommentContainer>
      </div>

      <div className={`${clsPrefix}__screen ${clsPrefix}__screen-eight`}>
        <ShowContainer isInScreen={true}></ShowContainer>
      </div>

      <div className={`${clsPrefix}__screen ${clsPrefix}__screen-three`}>
        <PanelContainer selector='.p-cy-homepage' title='基础评论功能' backgroundColor='#f9f9f9'>
          {(isShow) => <BasicFeaturePanel isInScreen={isShow} />}
        </PanelContainer>
      </div>

      <div className={`${clsPrefix}__screen ${clsPrefix}__screen-five`}>
        <PanelContainer selector='.p-cy-homepage' title='强大的管理功能' >
          {(isShow) => <ManageFeaturePanel isInScreen={isShow} />}
        </PanelContainer>
      </div>

      <div className={`${clsPrefix}__screen ${clsPrefix}__screen-six`}>
        <PanelContainer selector='.p-cy-homepage' title='丰富的评论互动功能' backgroundColor='#f9f9f9'>
          {(isShow) => <LaboratoryCommentPanel isInScreen={isShow} />}
        </PanelContainer>
      </div>

      <div className={`${clsPrefix}__screen ${clsPrefix}__screen-seven`}>
        <PanelContainer selector='.p-cy-homepage'>
          {(isShow) => <UsersPanel isInScreen={isShow} />}
        </PanelContainer>
      </div>

      <OurInfomation className={`${clsPrefix}__information`} callingCardList = {INFOMATIONCONTENT.CALLINGCARDSCONTENT} children=''/>

      <Footer contentBefore={FOOTER_CONTENT.contentBefore}
              linkContent={FOOTER_CONTENT.linkContent}
              linkUrl={FOOTER_CONTENT.linkUrl}
              contentAfter={FOOTER_CONTENT.contentAfter}/>

      <Modal
        visible={isNoticeModalVisible}
        onClose={handleCloseModal}
        header='更新公告'
        headerStyle={{ background: '#207CD3', color: '#ffffff' }}
        className='notices-modal'
      >
        <div className='notices-modal__content'>
          <div style={{ overflow: 'auto' }}>
          {
            noticeList.map((item, index) => (
              <UpdateItem
                key={index}
                title={item.title}
                imgUrl={item.coverImg}
                publicTime={item.publicDate}
                description={item.content}
              />
            ))
          }
          </div>
        </div>
      </Modal>

    </div>
  )
}

// @ts-ignore
CyHompage.Layout = cyLayout

export default CyHompage
